import React from 'react';
import useQuery from '../hooks/useQuery';  // Assuming useQuery is in a hooks folder

const VerificationMessage = () => {
  const query = useQuery();
  const message = query.get('message');
  const success = query.get('success');

  if (!message) return null; // Do not render if there is no message

  return (
    <div style={{ padding: 20, backgroundColor: success === 'true' ? 'lightgreen' : 'lightcoral', color: 'darkslategray' }}>
      {message}
    </div>
  );
};

export default VerificationMessage;

